module.exports = __webpack_public_path__ + "img/tpc-printable-flyers-3.5d937b47.webp";